import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../../../app/shared/services/user.service';
import { AppService } from '../../../app.service';
import { ImplementDetailsService } from '../implement-details/implement-details.service';
import { SelectionNewImplementComponent } from '../setup-implement/add-new-componentType/add-new-componentType.component';
import { GenericIdName, ImplementsAndModelsVM, ImpTypeOptionalFields, ReportStyles } from '../setup-implement/setup-implement.model';
import { AddNewImplementAndBuildnoComponent } from './add-new-implement-and-buildno/add-new-implement-and-buildno.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-implement-model-setup',
  templateUrl: './implement-model-setup.component.html',
  styleUrls: ['./implement-model-setup.component.scss']
})
export class ImplementModelSetupComponent implements OnInit {

  constructor(private _appService: AppService, private toastr: NotificationsService, private _user: UserService,
    private _implementService: ImplementDetailsService, public dialog: MatDialog,) { }

    IsSupportTeam: boolean = false;
    selectImplementTypeId: number = 0;
    selectImplementModelId: number = 0;
    implementTypeList: GenericIdName[];
    modelsList: GenericIdName[];
    resultList: ImplementsAndModelsVM[];
    isSearchedResultnull: boolean = false
    isDispalyModel: boolean = true
    isDispalyImpType: boolean = true
    editableAssetDefination: boolean = true;
    previousAssetDefination: string;
    assetDef: string = "";
    assetModel: string = "";
    previousModel: string;
    Capacity: boolean
    IsAddButton: boolean = false;
    IsUpdateButton: boolean = true;
    GETType: boolean
    BCMSetup: boolean
    TonSetup: boolean
    selectTypeId: number = 0;
    selectedDispalyImpType: string;
    selectedDispalyImpType_: string ="";
    isDispaly: boolean = true;
    inputModelName: string ="";
    GETTypeList: GenericIdName[];
    selectedRow: number | null = null;
    selectedAssetRow: number | null = null;
    ngOnInit() {
      this._appService.setPageTitle('Implement Model');
      this.LoadJobRoles();
      this.LoadImplementTypes();
      this.LoadAllBuiltNos();
      this.LoadGETTypesList();
      this.LoadGETReportStyle();
    }
  
    //Code to allow Edit Asset Defination
    editAssetDefination(result: ImplementsAndModelsVM, index: number) {
      this.selectedRow = index;
      this.isDispaly = false;
  
      //this.editableAssetDefination = false;
      this.previousAssetDefination = result.ImpTypeName;
    }
  
    saveAssetDefination(result: ImplementsAndModelsVM) {
      this.editableAssetDefination = true;
      this.selectedRow = null;
      this._implementService.updateAssetDefination(result.ImplementTypeId, result.ImpTypeName).subscribe(res => {
  
        if (res == true) {
          this.toastr.success("Saved Sucessfully")
          this.IsUpdateButton = true;
          this.ResetAll();
          this.SeachResult();
        }
        else {
          this.toastr.error("Data already exists, please check and try again")
  
        }
      })
    }
  
    CancelAssetDefination(result: ImplementsAndModelsVM) {
      this.selectedRow = null;
      this.isDispaly = true;
      result.ImpTypeName = this.previousAssetDefination;
      return result;
  
    }
    //Code end
    //Code to allow Edit Edit
    editModel(result: ImplementsAndModelsVM, index: number) {
      this.selectedAssetRow = index;
      this.isDispaly = false;
  
      //this.editableAssetDefination = false;
      this.previousModel = result.ModelName;
    }
  
    saveModel(result: ImplementsAndModelsVM) {
      this.editableAssetDefination = true;
      this.selectedAssetRow = null;
      this._implementService.updateModelName(result.ImplementTypeId, result.ModelName, result.ImpementId).subscribe(res => {
  
        if (res == true) {
          this.toastr.success("Saved Sucessfully")
          this.ResetAll();
          this.SeachResult();
        }
        else {
          this.toastr.error("Something went Wrong !!!")
  
        }
      })
    }
  
    CancelModel(result: ImplementsAndModelsVM) {
      this.selectedAssetRow = null;
      this.isDispaly = true;
      result.ModelName = this.previousModel;
      return result;
    }
    //Code end
  
  
    LoadGETTypesList() {
      this._implementService.GetAllGETTypes().subscribe(res => {
        this.GETTypeList = res;
      })
    }
ReportStyles:ReportStyles[]=[];
     
    LoadGETReportStyle() {
      this._implementService.LoadGETReportStyle().subscribe(res => {
        this.ReportStyles = res;
      })
    }
    LoadImplementTypeFields() {
      console.log("this.selectImplementTypeId", this.selectImplementTypeId)
      this._implementService.GETOptionalFieldsForImplemetType(this.selectImplementTypeId).subscribe(res => {
  
        this.Capacity = res.Capacity;
        this.GETType = res.GETType;
        this.BCMSetup = res.BCMSetup;
        this.TonSetup = res.TonSetup;
        this.selectTypeId = res.GETTypeId;
  
      })
    }
    LoadImplementTypeField() {
      console.log("this.selectImplementTypeId", this.selectImplementTypeId)
      this._implementService.GETOptionalFieldsForImplemetType(this.selectImplementTypeId).subscribe(res => {
  
        this.Capacity = res.Capacity;
        this.GETType = res.GETType;
        this.BCMSetup = res.BCMSetup;
        this.TonSetup = res.TonSetup;
        //this.selectTypeId = res.GETTypeId;
  
      })
    }
  
  
  
    SaveOptionalFields() {
  
    }
    changeCheckbox(values: string) {
      switch (values) {
        case 'Capacity':
          this.IsSupportTeam = true;
          break;
        case 'GETType':
          this.IsSupportTeam = true;
          break;
        case 'BCMSetup':
          this.IsSupportTeam = true;
          break;
        case 'TonSetup':
          this.IsSupportTeam = true;
          break;
      }
    }
    ChangeImplementType() {
      //this.LoadImplementTypeFields();
      // this.selectImplementTypeId=this.selectImplementTypeId;
  
      // this.LoadImplementTypeField();
    }
  
    LoadJobRoles() {
      this._user.getUserJobRoles().subscribe(roles => {
        roles.forEach(r => {
          switch (r.Name) {
            case 'Super User':
              this.IsSupportTeam = true;
              break;
          }
        });
  
      })
    }
  
    LoadImplementTypes() {
      this._implementService.GetImplementTypes().subscribe(res => {
        console.log("res", res)
        this.implementTypeList = res;
      })
    }
  
    LoadAllBuiltNos() {
      this._implementService.GetAllGETModels().subscribe(res => {
        console.log("buil no list", res)
        this.modelsList = res;
      })
    }
  
    ChangeType() {
      //geeting the asset defination based on asset type selection 
      let currentselectTypeId = this.selectTypeId;
      this._implementService.GetSelectedImplementTypes(this.selectTypeId).subscribe(res => {
        console.log("res", res)
        this.implementTypeList = res;
      })
    }
  
    ResetAll() {
      this.selectTypeId = 0;
      this.selectImplementTypeId = 0
      this.selectImplementModelId = 0
      this.resultList = []
      this.isSearchedResultnull = false;
      this.IsUpdateButton = true;
      this.IsAddButton = false;
      this.isDispalyImpType = true;
      this.isDispalyModel = true;
      this.selectedDispalyImpType_ = "";
      this.inputModelName = "";
    }
  
    SeachResult() {
      //this.ChangeType();
      this._implementService.GETImplmentModels(this.selectTypeId).subscribe(res => {
        this.resultList = res;
  
        if (res.length == 0) {
          this.toastr.success("No Record found.");
          //this.isSearchedResultnull = true
        }
        else this.isSearchedResultnull = false
      })
    }
  
    AddImplementModel() {
      if (this.inputModelName !== "" && this.selectedDispalyImpType_ !== "") {
        
        this._implementService.addNewImplement(this.selectTypeId, this.selectedDispalyImpType_,
          this.inputModelName).subscribe(res => {
            if (res == true) {
  
              this.toastr.success("Saved Sucessfully");
              this.ResetAll();
              this.SeachResult();
            }
            else {
              this.toastr.error("Data already exists, please check and try again")
  
            }
          })
      }else{
        this.toastr.error("Please fill the blank fields first")
      }
  
    }
    selectRow(data) {
      this.isDispalyImpType = true;
      this.isDispalyModel = true;
      this.IsUpdateButton = false;
      this.IsAddButton = true;
      console.log(data);
      this.selectImplementTypeId = data.ImplementTypeId;
      this.selectImplementModelId = data.ModelId;
  
      this.LoadImplementTypeFields();
    }
  
    UpdateOptionalFiled() {
      let params = new ImpTypeOptionalFields();
      params.ImplementTypeId = this.selectImplementTypeId;
      params.BCMSetup = this.BCMSetup;
      params.TonSetup = this.TonSetup;
      params.GETType = this.GETType;
      params.Capacity = this.Capacity;
      params.GETTypeId = this.selectTypeId;
  
      this._implementService.UpdateOptionalDatFieldsImplementTpe(params).subscribe(res => {
        if (res) {
          this.toastr.success("Update Optional Fields Sucessfully");
          this._implementService.GETImplmentModels(this.selectTypeId).subscribe(res => {
            this.resultList = res;
          });
        } else {
          this.toastr.error("Error saving data")
  
        }
      })
    }
    openAddDialog() {
      this.selectImplementModelId = this.selectImplementModelId;
      this.isDispalyModel = false;
      this.IsAddButton = false;
    }
  
    OpenImplementType() {
      this.isDispalyImpType = false;
      this.IsAddButton = false;
  
    }
  
  StatusChange(Id:number,reportStyleId: number){
 this._implementService.UpdateGETAssetReportStyle(Id,reportStyleId).subscribe(res => {
        if (res) {
          this.toastr.success("Report Style Updated Sucessfully");
          this._implementService.GETImplmentModels(this.selectTypeId).subscribe(res => {
          
            this.resultList = res;
          });
        } else {
          this.toastr.error("Error saving data")
  
        }
      })
  }
  
  
  }
  